import React, { ReactElement } from 'react'
import { Flex } from 'theme-ui'
import { Svg } from 'ui'
import ProtectionIcon from 'images/organization/features/malware/protection-icon.svg'
import ProtectionBg from 'images/organization/features/malware/protection-bg.svg'
import BlockMaliciousDomainsIllustration from 'images/organization/features/malware/block-malicious-domains.png'
import IpLevelBlockingIllustration from 'images/organization/features/malware/ip-level-blocking.svg'
import AiPoweredMalwareIdentificationIllustration from 'images/organization/features/malware/ai-powered-malware-identification.png'
import { TextWithBreakpointVariant } from 'ui/TextWithBreakpointVariant'
import CommonSectionItem from 'components/Organization/LandingPageCommonComponents/CommonSectionItem'

export default function Protection(): ReactElement {
  return (
    <Flex
      sx={{
        width: '100%',
        flexDirection: 'column',
        gap: ['4.2rem', '4.8rem'],
        justifyContent: 'center',
        textAlign: 'center',
        px: '1.6rem',
      }}
    >
      <Flex
        sx={{ position: 'relative', flexDirection: 'column', gap: '1.6rem', alignItems: 'center' }}
      >
        <Svg svg={ProtectionIcon} descriptiveText="Triple layer protection icon" />
        <TextWithBreakpointVariant
          variant={['size24Weight600', 'size40Weight600']}
          sx={{ color: 'white', mt: '-4rem', zIndex: 'zIndex1' }}
        >
          Triple layer threat protection
        </TextWithBreakpointVariant>
        <Svg
          svg={ProtectionBg}
          sx={{ position: 'absolute', top: '-5rem', width: ['70rem', 'auto'], zIndex: 'zIndex0' }}
          descriptiveText="Decorative background pattern"
        />
      </Flex>
      <Flex
        sx={{ flexDirection: 'column', gap: '6.4rem', alignItems: 'center', zIndex: 'zIndex2' }}
      >
        <CommonSectionItem
          image={BlockMaliciousDomainsIllustration}
          title="Block malicious domains"
          description="Identify and block known malicious domains compiled from trusted security researchers worldwide.
         This prevents access to harmful content, ensuring that your network remains safe and uncompromised."
        />
        {/* png is unavailable in figma */}
        <CommonSectionItem
          customImage={
            <Flex
              sx={{
                height: '100%',
                width: '100%',
                maxHeight: '40rem',
                maxWidth: '49.1rem',
                border: '1px solid',
                borderColor: 'blueYonder20',
                borderRadius: '1.2rem',
                background: 'blue800',
                justifyContent: 'center',
                alignItems: 'center',
                p: '3.5rem',
              }}
            >
              <Svg
                svg={IpLevelBlockingIllustration}
                sx={{
                  flexShrink: 'inherit',
                  height: '100%',
                  width: '100%',
                }}
                descriptiveText="IP level blocking illustration"
              />
            </Flex>
          }
          isReverse
          title="IP level blocking"
          description="Block domains that resolve to known malicious IP addresses, preventing access even if the domain name changes.
         This provides additional protection against evolving threats that attempt to bypass traditional domain-based filters."
        />
        <CommonSectionItem
          image={AiPoweredMalwareIdentificationIllustration}
          title="AI powered malware identification"
          description="Use AI-powered detection to identify and block threats in real-time, enhancing proactive defenses.
         The AI learns from new threat patterns to continuously improve its detection capabilities, providing robust, adaptive protection."
        />
      </Flex>
    </Flex>
  )
}
